import Persion from './Persion.vue'
export default Persion



// WEBPACK FOOTER //
// ./src/components/persion/index.js